<template>
  <div v-loading="loader">
    <div class="nav-bar">
      <div class="nav-bar__tabs tabs">
        <div class="tabs__item">
          <router-link class="tabs__link tabs__link--active"
                       :to="`/transactions/${$route.params.id}/tx/1`"
          >Transaction</router-link>
        </div>
        <div class="tabs__item">
          <router-link class="tabs__link"
                       :to="`/transactions/${$route.params.id}/holders/1`"
          >Holders</router-link>
        </div>
      </div>
      <div class="nav-bar__pages page">
        <router-link class="page__first" :to="get_first">Last</router-link>
        <router-link class="page__prev" :to="get_prev">&lt;</router-link>
        <span class="page__current"><b>{{$route.params.num}}</b> of {{max_page}}</span>
        <router-link class="page__next" :to="get_next">&gt;</router-link>
        <router-link class="page__last" :to="get_last">Last</router-link>
      </div>
      <div class="nav-bar__form-search">
        <input v-model="search_txt" name="search-token" placeholder="Search" type="search">
        <button>
          <img :src="search" alt="Search">
        </button>
      </div>
    </div>
    <div class="table-transactions">
      <div class="table-transactions__header trans">
        <div class="trans__timestamp">
          Timestamp
        </div>
        <div class="trans__addresses">
          Tx Id /
          <br> Sender /
          <br> Recipient
        </div>
        <div class="trans__txid">
          Tx Id
        </div>
        <div class="trans__sender">
          Sender
        </div>
        <div class="trans__recipient">
          Recipient
        </div>
        <div class="trans__amount-fee">
          Amount /
          <br>
          <span class="grey">XEM Fee</span>
        </div>
        <div class="trans__amount">
          Amount
        </div>
        <div class="trans__fee">
          XEM Fee
        </div>
      </div>
      <div class="table-transactions__item trans" v-for="table in data_table">
        <div class="trans__timestamp">
          <div class="trans__timestamp-name">
            Timestamp
          </div>
          <div class="trans__timestamp-value">
            {{table.timeStamp}}
          </div>
        </div>
        <div class="trans__addresses--recent">
          <p><router-link :to="'/tx/' + table.hash">{{table.hash}}</router-link></p>
          <p><router-link :to="'/address/' + table.sender + '/tx/1'">{{table.sender}}</router-link></p>
          <p><router-link :to="'/address/' + table.recipient + '/tx/1'">{{table.recipient}}</router-link></p>
        </div>
        <div class="trans__txid">
          <div class="trans__txid-name">
            Tx Id
          </div>
          <div class="trans__txid-value">
            <router-link :to="'/tx/' + table.hash">{{table.hash}}</router-link>
          </div>
        </div>
        <div class="trans__sender">
          <div class="trans__sender-name">
            Sender
          </div>
          <div class="trans__sender-value">
            <router-link :to="'/address/' + table.sender + '/tx/1'">{{table.sender}}</router-link>
          </div>
        </div>
        <div class="trans__recipient">
          <div class="trans__recipient-name">
            Recipient
          </div>
          <div class="trans__recipient-value">
            <router-link :to="'/address/' + table.recipient + '/tx/1'">{{table.recipient}}</router-link>
          </div>
        </div>
        <div class="trans__amount-fee">
          <p>{{divisibility(table.quantity, table.div)}}</p>
          <p class="grey"> {{divisibility(table.fee)}}</p>
        </div>
        <div class="trans__amount">
          <div class="trans__amount-name">
            Amount
          </div>
          <div class="trans__amount-value">
            {{divisibility(table.quantity, table.div)}}
          </div>
        </div>
        <div class="trans__fee">
          <div class="trans__fee-name">
            XEM Fee
          </div>
          <div class="trans__fee-value">
            {{divisibility(table.fee)}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MosaicProxy from '../../proxies/MosaicProxy';
  import moment from 'moment';
  import { createNamespacedHelpers } from 'vuex';
  import { divisibility } from '../../utils/Math_util';
  const { mapState, mapActions } = createNamespacedHelpers('core');
  import search from './../../assets/images/icon/search.svg'
  export default {
    props: ['txCount'],
    name: 'TableTransactions',
    async mounted() {
      this.get_data(this.$route.params.num);
    },
    computed: {
      data_table() {
        return  this.tableData.filter(data => !this.search_txt
          || data.hash.toLowerCase().includes(this.search_txt.toLowerCase())
          || data.sender.toLowerCase().includes(this.search_txt.toLowerCase())
          || data.recipient.toLowerCase().includes(this.search_txt.toLowerCase())
        )
      },
      ...mapState(['detail']),
      max_page() {
        return Math.ceil(Number(this.detail.tx) / 15);
      },
      get_prev() {
        const prev = Number(this.$route.params.num) - 1;
        if (prev < 1) {
          return `/transactions/${this.$route.params.id}/tx/1`;
        }
        return `/transactions/${this.$route.params.id}/tx/${prev}`;
      },
      get_next() {
        const next = Number(this.$route.params.num) + 1;
        if (next > this.max_page) {
          return `/transactions/${this.$route.params.id}/tx/${this.max_page}`;
        }
        return `/transactions/${this.$route.params.id}/tx/${next}`;
      },
      get_last() {
        return `/transactions/${this.$route.params.id}/tx/${this.max_page}`;
      },
      get_first() {
        return `/transactions/${this.$route.params.id}/tx/1`;

      }
    },
    watch: {
      '$route' (to, from) {
        this.get_data(this.$route.params.num);
      }
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex & 1 ? 'odd-row' : 'bdd-row';
      },
      async tx_route(current) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        this.$router.push({
          name: 'tx.table',
          params: { num: current }
        });
        await this.get_data(current);
        loading.close();
      },
      async get_data(page) {
        const mosaics_proxy = new MosaicProxy();
        this.tableData = await mosaics_proxy.get_mosaic_tx_list(this.$route.params.id, page);
        const nemEpoch = Date.UTC(2015, 2, 29, 0, 6, 25, 0);
        this.tableData = this.tableData.map((data) => {
          const txTimestamp = new Date(nemEpoch + (data.timeStamp * 1000));
          return {
            ...data,
            timeStamp: moment(txTimestamp)
              .format('DD.MM.YYYY, HH:mm:ss')
          };
        });
        this.loader = false;
      }
    },
    data: () => ({
      loader: true,
      tableData: [],
      divisibility: divisibility,
      search,
      search_txt: ''
    })
  };
</script>

<style scoped lang="scss">
  .footer-tx {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 60px;
  }

  .amount-tb {
    text-align: right;
    height: 70px;

    span {
      display: block;
      font-size: 12px;
      color: #ccc;
    }
  }
</style>
